import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import { AppsResponse, Cluster, DeploymentsApi, Teams } from './types';
import { ResponseError } from '@backstage/errors';
import { omitBy, isNil } from 'lodash';

export interface DeploymentsClientOptions {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
}

export class DeploymentsClient implements DeploymentsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: DeploymentsClientOptions) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getApps(params: Record<string, string>): Promise<AppsResponse> {
    const baseUrl = await this.discoveryApi.getBaseUrl('deployments');

    const qp = new URLSearchParams(omitBy(params, isNil)).toString();
    let url = `${baseUrl}/apps`;

    if (qp.length > 0) {
      url += `?${qp}`;
    }

    const res = await this.fetchApi.fetch(url, {});

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data: AppsResponse = await res.json();
    return data;
  }

  async getClusters(): Promise<Cluster[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl('deployments');
    const res = await this.fetchApi.fetch(`${baseUrl}/clusters`);

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data: Cluster[] = await res.json();
    return data;
  }

  async getRepositories(): Promise<string[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl('deployments');
    const res = await this.fetchApi.fetch(`${baseUrl}/repositories`);

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data: string[] = await res.json();
    return data;
  }

  async getTeams(): Promise<Teams> {
    const baseUrl = await this.discoveryApi.getBaseUrl('deployments');
    const res = await this.fetchApi.fetch(`${baseUrl}/teams`);

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data: Teams = await res.json();
    return data;
  }
}
